export default __webpack_public_path__ + "static/media/excel.0b08e5eb.svg";